import { formatDistanceToNow } from "date-fns";
import i18n from "../../i18n";

export const formatDateTime = (date: Date) =>
  date.toLocaleString(i18n.language, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour12: false,
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short",
  });

export const formatDate = (date: Date) =>
  date.toLocaleDateString(i18n.language, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

export const formatDistanceToNowInDays = (date: Date) => {
  const oneDay = 1000 * 3600 * 24;
  const distance = Date.now() - date.getTime();
  if (distance < oneDay && distance > 0) {
    return i18n.t("common:today");
  }
  return formatDistanceToNow(date, { addSuffix: true });
};

export const formatISOTimestampToLocal = (isoString: string): string => {
  const date = new Date(isoString);
  if (isNaN(date.getTime())) {
    return isoString;
  }
  
  return date.toLocaleString(i18n.language, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
  });
};


export const formatDateOnlyToLocal = (dateStr: string): string => {
  const date = new Date(dateStr + "T00:00:00"); // Parse as local date
  if (isNaN(date.getTime())) {
    return dateStr;
  }
  
  return date.toLocaleDateString(i18n.language, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

/**
 * Format a fullValue string by replacing ISO timestamps and date-only strings with local timezone formatted dates
 * Example: "item (recorded: 2026-01-22T00:00:00.000Z)" -> "item (recorded: Jan 22, 2026, 20:00 PST)"
 * Example: "item (started: 2026-01-21)" -> "item (started: Jan 21, 2026)"
 */
export const formatFullValueWithLocalDates = (fullValue: string): string => {
  // First replace ISO timestamps (e.g., "2026-01-22T00:00:00.000Z")
  let formatted = fullValue.replace(
    /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z)/g,
    (match) => formatISOTimestampToLocal(match)
  );
  
  // Then replace date-only strings (YYYY-MM-DD) that appear after "started:" or "recorded:"
  formatted = formatted.replace(
    /(started|recorded):\s*(\d{4}-\d{2}-\d{2})(?![T\d])/gi,
    (match, prefix, dateStr) => `${prefix}: ${formatDateOnlyToLocal(dateStr)}`
  );
  
  return formatted;
};
